(() => {
  const SECTION_SELECTOR = '[data-cross-sells]';
  const ITEM_SELECTOR = '[data-cross-sell-item]';
  const CHECKBOX_SELECTOR = '[data-cross-sell]';
  const COPY_SELECTOR = '.mcp-accessories__copy';

  const LABELS = {
    en: 'Recommended',
    es: 'Recomendado',
    de: 'Empfohlen',
    fr: 'Recommandé',
    it: 'Consigliato',
    pt: 'Recomendado',
    nl: 'Aanbevolen',
  };

  const label = () => {
    const lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
    return LABELS[lang] || LABELS.en;
  };

  const highlightFirst = (section) => {
    if (section.dataset.mcRecommended === 'true') return;
    section.dataset.mcRecommended = 'true';

    const item = [...section.querySelectorAll(ITEM_SELECTOR)].find((candidate) => {
      const checkbox = candidate.querySelector(CHECKBOX_SELECTOR);
      return checkbox && !checkbox.disabled;
    });
    if (!item) return;

    item.classList.add('is-recommended');

    const copy = item.querySelector(COPY_SELECTOR);
    if (!copy || copy.querySelector('.mcp-accessories__recommended')) return;

    const badge = document.createElement('span');
    badge.className = 'mcp-accessories__recommended';
    badge.textContent = label();
    copy.prepend(badge);
  };

  const scan = (root = document) => {
    if (root instanceof Element && root.matches(SECTION_SELECTOR)) highlightFirst(root);
    if (!root.querySelectorAll) return;
    root.querySelectorAll(SECTION_SELECTOR).forEach(highlightFirst);
  };

  const start = () => {
    scan();
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();